import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAuthSelector } from 'js/store/hooks';
import { IDataMap } from 'js/components/common/ChangeForm/hooks/useOnCombinedSubmit/types';

export const useGetBeforeRegistrationHandler = () => {
    const beforeRegistrationHooks = useAuthSelector(prop('beforeRegistrationHooks'));

    return useCallback(async ({ dataMap }: { dataMap: IDataMap }): Promise<{ dataMap: IDataMap }> => {
        let promise = Promise.resolve({ dataMap });

        for (const hook of beforeRegistrationHooks) {
            promise = promise.then((...args) => hook(...args));
        }

        const { dataMap: modifiedDataMap } = await promise;

        return {
            dataMap: modifiedDataMap
        };
    }, [beforeRegistrationHooks]);
};
